import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";

const Documents = (props) => {
    const { documentsList,searchText , tab} = props;
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Documents</div>
            {documentsList.length > 0 &&
                <>
                    <div className='search-product-list'>
                        <div className="search-documents-list">
                            {documentsList.length > 0 && documentsList.map((v, i) => (
                                <React.Fragment key={i}>
                                    {
                                        i < 5 &&
                                        <a href={v.AssetUrl} target={v.DocumentType && v.DocumentType.toLowerCase().includes('videos') ? '_blank':'_self'}  className="search-documents-list-item cursor-pointer">
                                            <div>
                                                <span className="documents-date">{v.DatePublishedObjectString}  </span>
                                                <div className="documents-title">{v.Title}</div>
                                                <div className="documents-text">
                                                    {v.Manufacturer}
                                                </div>
                                            </div>
                                            <div className="document-info">
                                                {v.DocumentType}
                                            </div>
                                        </a>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                    <a href={HomePage.makeHomeTabsListRouteURL(tab) + '&search='+searchText}
                        className="text-center mt-auto pb-3">
                        <div className="bs5 btn btn-sm btn-primary">VIEW ALL DOCUMENT RESULtS</div>
                    </a>
                </>
            }
            {Object.keys(documentsList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Documents